import { useTranslation } from "react-i18next";
import { useModal } from "context";
import { SignupForm } from "modals";
import { useSelector } from "react-redux";
import { selectIsAuthenticated, selectUserType } from "store/auth/selectors";
import { useNavigate } from "react-router";
import { useState } from "react";
import styles from "./styles.module.scss";

const JoinTheCommunitySection = () => {
  const [t] = useTranslation("global");
  const { openModal } = useModal();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const userType = useSelector(selectUserType);
  const navigate = useNavigate();
  
  const [activeAdvantage, setActiveAdvantage] = useState(1); // Start with first item active

  const handleJoinCommunityClick = () => {
    if (isAuthenticated && userType === "provider") {
      navigate("/create-space/step1");
    } else {
      openModal({
        content: <SignupForm type="provider" />,
        title: t("modal.register.titleProvider"),
      });
    }
  };

  // Handle click on advantage item
  const handleAdvantageClick = (advantageId) => {
    setActiveAdvantage(advantageId);
  };

  // Advantages data for better maintainability
  const advantages = [
    {
      id: 1,
      title: t("home.freeAndWithoutLimitTitle"),
      content: t("home.freeAndWithoutLimitContent"),
    },
    {
      id: 2,
      title: t("home.highQualityRequestsTitle"),
      content: t("home.highQualityRequestsContent"),
    },
    {
      id: 3,
      title: t("home.visibilityTitle"),
      content: t("home.visibilityContent"),
    }
  ];

  return (
    <section className="mediumContainer">
      <section className={styles.joinTheCommunity}>
        <div className={styles.backgroundOverlay}></div>
        <div className={styles.content}>
          <h2
            className={styles.heading} 
            dangerouslySetInnerHTML={{ __html: t("home.joinTheCommunity") }}
          />
          <p 
            className={styles.subheading} 
            dangerouslySetInnerHTML={{ __html: t("home.joinTheCommunitySubHeading") }}
          />
          <button className={styles.button} onClick={handleJoinCommunityClick}>
            {t("home.joinTheCommunityButton")}
          </button>
          
          <div className={styles.advantages}>
            <h3 
              className={styles.advantagesTitle}
              dangerouslySetInnerHTML={{ __html: t("home.joinTheCommunityAdvantagesTitle") }}
            />
            
            {advantages.map((advantage) => (
              <div 
                key={advantage.id}
                className={`${styles.advantagesItem} ${activeAdvantage === advantage.id ? styles.active : ''}`}
                onClick={() => handleAdvantageClick(advantage.id)}
              >
                <p
                  className={styles.advantagesItemTitle}
                  dangerouslySetInnerHTML={{ __html: advantage.title }}
                />
                <p 
                  className={styles.advantagesItemText}
                  dangerouslySetInnerHTML={{ __html: advantage.content }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </section>
  );
};

export default JoinTheCommunitySection;